import React from 'react';
import { Typography } from 'antd';
import { CloudOutlined } from '@ant-design/icons';
import { CloudWatchLogsTab } from '../components/cloudwatch-logs/CloudWatchLogsTab';

const { Title } = Typography;

export const AdminCloudWatchLogsPage: React.FC = () => {
    return (
        <div>
            <Title level={3} style={{ marginBottom: 24 }}>
                <CloudOutlined style={{ marginRight: 8 }} />
                CloudWatch Logs
            </Title>
            <CloudWatchLogsTab />
        </div>
    );
};
